import React from 'react';
import classNames from 'classnames';
import {default as ReactSelect} from 'react-select';

import './styles.css';

class Search extends React.Component<any> {
  state = {
    searchedOption: null
  };

  onChange = value => {
    this.setState({searchedOption: value});
  };

  render() {
    return (
      <div className={classNames('Search', this.props.className)}>
        <ReactSelect
          searchable={this.props.searchable || true}
          arrowRenderer={undefined}
          matchProp="label"
          placeholder={this.props.placeholder}
          filterOptions={this.props.filterOptions || true}
          value={this.props.value || this.state.searchedOption}
          options={this.props.options}
          onChange={this.props.onChange || this.onChange}
          /* https://github.com/erikras/redux-form/issues/1185 */
          onBlur={() =>
            this.props.onBlur && this.props.onBlur(this.props.value)
          }
          onInputKeyDown={this.props.onInputKeyDown}
          onValueClick={this.props.onValueClick}
          isLoading={this.props.isLoading || false}
          onInputChange={this.props.onInputChange}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default Search;
